import { authHeaders, getBackendBaseUrl } from '../../services/nodeAuthService';

export const PERMISSIONS_LOADING  = '[permissions] loading';
export const PERMISSIONS_LOADED   = '[permissions] loaded';
export const PERMISSIONS_FAILED   = '[permissions] failed';
export const PERMISSIONS_CLEARED  = '[permissions] cleared';

export function fetchPermissionsAction() {
  return async (dispatch) => {
    dispatch({ type: PERMISSIONS_LOADING });
    try {
      const [permRes, menuRes] = await Promise.all([
        fetch(`${getBackendBaseUrl()}/api/auth/my-permissions`, { headers: { ...authHeaders() } }),
        fetch(`${getBackendBaseUrl()}/api/admin/menus/my-menus`, { headers: { ...authHeaders() } }),
      ]);
      const data = await permRes.json().catch(() => ({}));
      const menuData = await menuRes.json().catch(() => ({}));

      if (!permRes.ok) {
        dispatch({ type: PERMISSIONS_FAILED, payload: data?.message || 'Failed to load permissions' });
        return;
      }
      if (!menuRes.ok) {
        dispatch({ type: PERMISSIONS_FAILED, payload: menuData?.message || 'Failed to load menus' });
        return;
      }

      // data.results.data = { isSuperAdmin: bool, permissions: [...] }
      const payload = data?.results?.data ?? data?.data ?? {};
      payload.menus = menuData?.results?.data?.menus ?? [];
      dispatch({ type: PERMISSIONS_LOADED, payload });
    } catch (err) {
      dispatch({ type: PERMISSIONS_FAILED, payload: err.message });
    }
  };
}

export function clearPermissionsAction() {
  return { type: PERMISSIONS_CLEARED };
}